module.exports = __webpack_public_path__ + "static/img/group_num.9fbf40d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/group_num.png
// module id = Z6R4
// module chunks = 52